module.exports = __webpack_public_path__ + "img/F120.b030b1ed.jpg";